<template>
  <div class="page">
    <div v-for="(item,index) in FAQStore.currentProblemsList">
      <h2>{{ item.topic }}</h2>
      <el-alert
          title="描述:"
          type="info"
          description="more text description"
          show-icon
          :closable="false"
          v-if="item.remark"
      >
        <template #default>
          <div v-html="item.remark" style="overflow:scroll"></div>
        </template>
      </el-alert>

      <el-checkbox-group v-model="FAQStore.answerListObj[item._id]" size="large" class="checkBoxGroup"
                         @change="checkboxChange(item)">
        <el-checkbox :label="option.mark" border size="large" v-for="option in item.options">
          <h3 style="letter-spacing: 2px;line-height: 110%;">{{ option.name }}</h3>
          <div v-if="option.remark" v-html="option.remark" class="checkBoxSubTitle"></div>
        </el-checkbox>
      </el-checkbox-group>

      <div v-if="item.isWrite && FAQStore.answerListObj[item._id]
      && FAQStore.answerListObj[item._id].includes(item.options.at(-1).mark)">
        <el-tag size="large" type="info" style="border-radius: 8px 8px 0 0;">{{ translateTitle('备注留言') }}</el-tag>
        <el-input
            v-model="FAQStore.answerContentObj[item._id]"
            maxlength="30"
            :placeholder="translateTitle('为了更快解决问题，请详细描述您遇到的问题')"
            show-word-limit
            :rows="5"
            type="textarea"
        />
      </div>
    </div>

    <div style="display:flex;flex-direction: row;justify-content: space-between;margin-top: 20px">
      <el-button @click="FAQStore.lastProblem" type="primary" size="large" id="demo"
                 :disabled="FAQStore.currentProblemsList[0] && !FAQStore.currentProblemsList[0].belongId">
        {{ translateTitle('上一问') }}
      </el-button>
      <el-button @click="nextProblem" type="primary" size="large" :disabled="isSelectedAnswer">
        {{ translateTitle('下一问') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import {reactive, toRefs, nextTick, onMounted} from "vue";
import {useFAQStore} from "@/store/modules/FAQ";
import {useRoute} from "vue-router";
import router from "@/router";
import {translateTitle} from "@/utils/i18n";

export default {
  name: "informationCollection",
  methods: {translateTitle},
  setup() {
    const FAQStore = useFAQStore()
    const route = useRoute()
    const state = reactive({
      isSelectedAnswer: true,
    })
    // 初始化判断参数，是否为直接进入二级目录模式
    if (!FAQStore.problemsList.length) {
      const {titleId} = route.query
      if (titleId && FAQStore.getNextProblemList(titleId)) console.log("参数进入模式")
      else router.push({path: "/FAQ", replace: true})
    }

    // 判断是非选项为单选，如果是单选则只可保留一个选项
    const checkboxChange = (item) => {
      const {options_type, _id} = item
      if (options_type === '1' && FAQStore.answerListObj[_id].length > 1) {
        FAQStore.answerListObj[_id].shift()
      } else if (!FAQStore.answerListObj[_id].length) {
        delete FAQStore.answerListObj[_id]
      }
      const answerListObj_key = Object.keys(FAQStore.answerListObj)
      state.isSelectedAnswer = !answerListObj_key.length
      // console.warn("show:::",state.isSelectedAnswer,answerListObj_key)
    }

    const nextProblem = async () => {
      await FAQStore.nextProblem()
      state.isSelectedAnswer = true
    }

    onMounted(() => {
      nextTick(() => {
        const videos = document.getElementsByTagName('video')
        for (let i = 0; i < videos.length; i++) {
          videos[i].setAttribute("controlslist", "nodownload")
          console.warn("warn:", videos[i])
        }
        // video.setAttribute("controlslist","nodownload")
        // console.warn("warn:",video)
      })
    })

    return {
      ...toRefs(state),
      FAQStore,
      checkboxChange,
      nextProblem
    }
  }
}
</script>
<style>
video, img {
  width: 100%;
  //width: 100% !important;
}

.el-dialog__header {
  padding: 0
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 48%;
  margin: 0 2% 8px 0;
}

.el-upload--picture-card {
  width: 100px;
  height: 100px;
}

.el-checkbox {
  white-space: break-spaces;
}

.el-checkbox.el-checkbox--large {
  height: auto;
  margin-bottom: 20px;
  margin-right: 0;
}
</style>
<style scoped>
.page {
  padding: 20px;
  min-height: calc(100vh - 40px);
  height: auto;
  background: linear-gradient(to left top, #EEF2FD, #F5FBFC 30%);
}

.checkBoxGroup {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}

.checkBoxSubTitle {
  color: #a1a1a1;
  margin: 10px 0;
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
}
</style>